import React, { useEffect, useState, Fragment, useCallback } from 'react'
import Layout from "../../components/Layout/Layout";
import { SearchIcon } from '@heroicons/react/solid'
import { DocumentDownloadIcon, QuestionMarkCircleIcon } from '@heroicons/react/outline'
import { useNavigate } from 'react-router-dom';
import LoanServices from '../../services/LoanServices';
import { convert, formatDate, DisplayTime } from '../../utils/convertDate';
import ActionDropdown from "../../components/ActionDropdown";
import Paginate from '../../utils/Paginate';
import { FormatMoney } from '../../utils/formatMoney';
import DatePicker from 'react-date-picker';
import ProgressCondition from "./loanDetailsComponents/ProgressCondition";



export default function Personal() {
    const navigate = useNavigate();
    const [loans, setLoan] = useState([]);
    const [search, setSearch] = useState("")
    const [totalPage, setTotalpage] = useState(1);
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [nextPage, setNextPage] = useState(false);
    const [pageLength, setPageLength] = useState("");
    const [progressState, setProgressState] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [loading, setLoading] = useState(false);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    });


    const List = useCallback(async (page, length, search, from, to, status) => {
        try{
          setLoading(true);
          const resp = await LoanServices.listLoans(page, length, search, from, to, status, "Personal");
          if(resp){
            setLoan([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount);
            setTotalpage(resp.data.totalPages);
            setPrev(resp.data.hasPreviousPage);
            setNextPage(resp.data.hasNextPage);
            setLoading(false);
          }
        } catch(error){
          setLoading(false)
        }
    }, [[pageIndex]])

    const handleStatus = async (text) => {
        text = text === "All" ? "" : text;
        setProgressState(text);
    }
    const searchLoan = async (text) => {
        setSearch(text);
    }
    const range = (e) => {
      e.preventDefault();
      const fromDate = formatDate(formValues.from);
      const toDate = formatDate(formValues.to);
      List(pageIndex, 10, search, convert(fromDate), convert(toDate), progressState);
    };

    const dateValidation = {
      fromHandler: (event) => {
        setFormValues({ ...formValues, from: event });
      },
      toHandler: (event) => {
        setFormValues({ ...formValues, to: event });
      }
    };
  
    useEffect(() => {
      const fromDate = formatDate(formValues.from);
      const toDate = formatDate(formValues.to);
      List(pageIndex, 10, search, convert(fromDate), convert(toDate), progressState);
    }, [pageIndex, formValues, search, progressState]);

    const ExportLoan = () => {
      
    }

    return (
        <>
            <Layout title={'Personal Loan'} pageTag={'loan'} current={'/loan/personal'}>
                <React.Fragment>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="sm:flex sm:items-center mt-10">
                            <div className="sm:flex-auto flex">
                                <div className=" relative rounded-md shadow-sm mr-3">
                                    <p className='text-sm leading-3 text-gray-500'>From</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                    </div>
                                </div>
                                <div className=" relative rounded-md shadow-sm mr-3">
                                    <p className='text-sm leading-3 text-gray-500'>To</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                    </div>
                                </div>
                                <div className="mt-5 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        name="user"
                                        id="user"
                                        onChange={(e) => searchLoan(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search"
                                    />
                                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext"> <p>Search by loan application reference and email address</p></span>
                                        </div>
                                    </div>
                                </div>                   
                                <div className='mt-5 ml-4'>
                                    <button
                                        onClick={range}
                                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>{loading ? "searching..." : "Search"}</button>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-0 sm:ml-16 sm:flex-none flex">
                                <button
                                onClick={ExportLoan}
                                    type="button"
                                    className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                                >
                                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                                    Export CSV
                                </button>                            
                            </div>
                        </div>
                        <div className='flex mt-2'>
                        <div className="mt-5 relative rounded-md shadow-sm mr-3">
                                    <select
                                        id="currency"
                                        name="currency"
                                        placeholder="Sort by"
                                        onChange={(e) => handleStatus(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full  pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                    >
                                        <option value=''>Filter by stage</option>
                                        <option value='Expired'>Expired</option>
                                        <option value='Declined'>Declined</option>
                                        <option value='Started'>Started</option>
                                        <option value='OrrAccepted'>Orr Accepted</option>
                                        <option value='BankStatementRequested'>Bank Statement Requested</option>
                                        <option value='BankStatementVerified'>Bank Statement Verified</option>
                                        <option value='BankStatementAnalysed'>Bank Statement Analysed</option>
                                        <option value='CreditBureauAnalysed'>Credit Bureau Analysed</option>
                                        <option value='EligibilityCalculated'>Eligibility Calculated</option>
                                        <option value='LoanSummaryCalculated'>Loan Summary Calculated</option>
                                        {/* <option value='EquityCntributionSecured'>Equity Contribution Secured</option> */}
                                        <option value='MandateInitiated'>Mandate Initiated</option>
                                        <option value='MandateApproved'>Mandate Approved</option>
                                        {/* <option value='PendingDebit'>Pending Debit</option> */}
                                        <option value='Approved'>Approved</option>
                                        <option value='PendingDisbursement'>Pending Disbursement</option>
                                        <option value='Disbursed'>Disbursed</option>
                                    </select>
                                </div>
                              
                        </div>
                        <div className='flex mt-8'>
                        </div>
                        {loans.length === 0 ? (
                            <div className=" mt-8"> No data available for these dates to show. </div>
                        ) :
                            <>
                                <div className="mt-8 flex flex-col">
                                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                            <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Loan Reference
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Account Name
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                 Account Number
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
Date Created
                                                             </th>
                                                             <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Time Created
                                                             </th>
                                                             <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Loan Amount
                                                            </th>
                                                           
                                                            {/* <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Total Loan Amount
                                                            </th> */}
                                                            {/* <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Eligible Amount
                                                            </th> */}
                                                            <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Credit Report
                                                            </th>
                                                            <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Loan Tenor
                                                            </th>
                                                            <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Loan Type
                                                            </th>
                                                            <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Progress State
                                                            </th>
                                                            <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Interest Rate
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                Interest Amount
                                                            </th>
                                                            <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Management Fee
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                Insurance Fee
                                                            </th>
                                                            <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                Effective Date
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] pr-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                Maturity Date
                                                            </th>
                                                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                Next Repayment Date
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                Approved Amount
                                                            </th>
                                                            <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                ORR Score
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem] px-1 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                State of Residence
                                                            </th>
                                                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                Approval Date
                                                            </th>
                                                            <th scope="col" className="min-w-[8rem]  px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                Expiry Date
                                                            </th>
                                                        
                                                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            </th>
                                                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                <span className="sr-only">Edit</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-200 bg-white">
                                                        {loans.map((person, i) => (
                                                            <tr key={i} className="bg-gray-50">
                                                                <td className="whitespace-nowrap pl-4  py-4 pr-3 text-sm font-medium text-indigo-600">{person.loanApplicationReference === null ? "N/A" : person.loanApplicationReference}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.customerLastName + " " + person.customerFirstName}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.disbursementAccountNumber}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{formatDate(person?.dateCreated)}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{DisplayTime(person?.dateCreated)}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{FormatMoney(person.amount)}</td>
                                                               
                                                                {/* <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{FormatMoney(person.totalLoanAmount)}</td> */}
                                                                {/* <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{FormatMoney(person.eligibleAmount)}</td> */}
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.isClean === true ? "Good" : "Bad"}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.loanTenor}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.loanType}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.loanApplicationProgressState}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.interestRate}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{FormatMoney(person.interestAmount)}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{FormatMoney(person.managementFeeAmount)}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{FormatMoney(person.insuranceFee)}</td> 
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.progressState === "pendingdisbursement" || person.progressState === "disbursed" ? formatDate(person.loanEffectiveDate) : "N/A"}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.progressState === "pendingdisbursement" || person.progressState === "disbursed" ? formatDate(person.loanMaturityDate) : "N/A"}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.progressState === "pendingdisbursement" || person.progressState === "disbursed" ? formatDate(person.nextRepaymentDate) : "N/A"}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{FormatMoney(person.approvedAmount)}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.orrScore}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.stateOfResidence === null ? 'N/A' : person.stateOfResidence}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500"> {person.loanApprovalDate === "0001-01-01T00:00:00" ?  "N/A" : formatDate(person.loanApprovalDate)}</td>
                                                                <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500"> {formatDate(person.expiryDate)}</td>
                                                              
                                                                                                                            
                                                                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                    <ActionDropdown
                                                                      items={[
                                                                        { label: "View Details", onClick: () => navigate(`/loan/view?id=${person.id}`) },
                                                                      ]}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Paginate
                  nextPage={nextPage}
                  pageIndex={pageIndex}
                  totalCount={pageNumber}
                  totalPages={totalPage}
                  prevPage={prevPage}
                  setPageIndex={setPageIndex}
                />
                            </>
                        }

                    </div>
                </React.Fragment>
            </Layout>
        </>
    )
}